<template>
  <router-view />
</template>

<style lang="scss">
:root {
  --background-colour: #f3f3f3;
  --font-size-tiny: 0.75rem;
  --font-size-small: 1rem;
  --font-size-medium: 3rem;
  --black: #000;
  --white: #fff;
  --grey: rgba(0, 0, 0, 0.7);
  --light-grey: rgba(0, 0, 0, 0.5);
  --least-heavy: 400;
  --medium-heavy: 500;
  --heavy: 700;
  --vertical-gap: 1.5rem;
  --horizontal-gap: 1.5rem;
  --accent-colour: #f40200;
}

@import url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap");

* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

body {
  background: var(--background-colour);
  font-family: "DM Sans", Arial, Helvetica, sans-serif;
  width: 100dvw;
  height: 100dvh;
}

#app {
  width: 100%;
  height: 100%;
}

input {
  border: none;
  width: 100%;
  border-radius: 0.926vw;
  border: 0.5px solid var(--light-grey);
  color: var(--black);
  font-family: "DM Sans";
  font-size: var(--font-size-small);
  font-style: normal;
  font-weight: var(--least-heavy);
  line-height: normal;
  padding: var(--vertical-gap) var(--horizontal-gap);
  background-color: transparent;
}

input::placeholder {
  color: var(--light-grey);
}

label {
  color: var(--black);
  font-family: "DM Sans";
  font-size: var(--font-size-small);
  font-style: normal;
  font-weight: var(--least-heavy);
  line-height: normal;
  background-color: transparent;
}

li {
  list-style: none;
}
</style>
